import React from 'react';
import { useSelector } from 'react-redux';
import { connect } from 'react-redux';
import { compose } from 'redux';
import './CollegeDistributeDisclaimerNote.scss';
import If from '../../Shared/If/If';
import PhoneNumberBranding from '../../Branding/PhoneNumberBranding';
import { DELIVERY_MAIL_CHECK_TO_SCHOOL } from 'src/settings/settings';
import { getDeliveryMethod } from '../../../redux/modules/sellDeliveryMethod/sellDeliveryMethod.selectors';
import { getProductTypes } from '../../../redux/modules/productTypes/productType.selectors';
import { collegeDisclaimerMap, ProductTypes } from '../../../settings/settings';
import { arrayToSentence } from '../../../utils/utils';

export const CollegeDistributeDisclaimerNote = ({ selectedProductTypes }) => {
  const deliveryMethod = useSelector(getDeliveryMethod);

  return (
    <div>
      <If test={deliveryMethod === DELIVERY_MAIL_CHECK_TO_SCHOOL}>
        <div className="e2e-distribute-disclaimer-note college-distribute-disclaimer-note">
          <span className="bold-style">PLEASE NOTE</span>: It generally takes 7
          to 10 business days for the school to receive the check and additional
          time for processing. If you need the funds sooner, you may cancel this
          transaction and review our other distribution methods, or{' '}
          <PhoneNumberBranding />.
        </div>
      </If>
      <div
        data-testid="taxpayers-footnote"
        className="e2e-distribute-disclaimer-note college-distribute-disclaimer-note"
      >
        It is the taxpayer's responsibility to substantiate a qualified
        distribution to the IRS. Therefore, it is important that you maintain
        accurate records and save any receipts related to educational expenses.
        If a distribution is nonqualified, the earnings portion of the
        distribution may be subject to federal income taxes and a 10% federal
        tax penalty may be applied. State taxes may also apply. The payee’s
        Social Security number will be used for tax reporting. Please see the{' '}
        {arrayToSentence(
          [
            selectedProductTypes.includes(ProductTypes.NATIONAL529) &&
              collegeDisclaimerMap.national,
            selectedProductTypes.includes(ProductTypes.MARYLAND529) &&
              collegeDisclaimerMap.maryland,
            selectedProductTypes.includes(ProductTypes.ALASKA529) &&
              collegeDisclaimerMap.alaska,
          ]
            .filter((v) => v)
            .map(({ name, type, url }) => (
              <a
                className={`e2e-${type}-disclosure-link college-branded-link college-distribute-disclaimer-disclosure-link`}
                href={url}
                rel="noopener noreferrer"
                key={type}
                target="_blank"
              >
                {name}
              </a>
            ))
        )}{' '}
        for more information.
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  productTypes: getProductTypes(state),
});

export default compose(connect(mapStateToProps))(
  CollegeDistributeDisclaimerNote
);
